import PropTypes from 'prop-types';
import classNames from 'classnames';

const BorderBox = (props) => {
    return (
        <div className="border-box__container">
            <section className={classNames('border-box', props.className)}>{props.children}</section>
        </div>
    );
};

BorderBox.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};

export default BorderBox;
